module.exports = __webpack_public_path__ + "img/test_ended.a2839421.svg";